import React from "react";
import styles from "./TableBodyWrapper.module.scss";

export interface ITableBodyWrapper {
  className?: string;
  children?: React.ReactNode;
}

export const TableBodyWrapper: React.FC<ITableBodyWrapper> = ({
  className,
  children,
}) => {
  return (
    <tbody className={`${styles.bodyWrapper} ${className}`}>{children}</tbody>
  );
};
